import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  approveUser,
  blockUser,
  deleteUser,
  listUsers,
  type ListUsersParams,
  makeAdmin,
  revokeAdmin,
  unblockUser,
} from "./api";

export const ADMIN_USERS_QK = ["admin", "users"] as const;

export function useAdminUsers(params: ListUsersParams) {
  return useQuery({
    queryKey: [...ADMIN_USERS_QK, params],
    queryFn: () => listUsers(params),
    staleTime: 5_000,
  });
}

function useAction<T>(fn: (id: string) => Promise<T>) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => qc.invalidateQueries({ queryKey: ADMIN_USERS_QK }),
  });
}

export const useApproveUser = () => useAction(approveUser);
export const useBlockUser = () => useAction(blockUser);
export const useUnblockUser = () => useAction(unblockUser);
export const useMakeAdmin = () => useAction(makeAdmin);
export const useRevokeAdmin = () => useAction(revokeAdmin);
export const useDeleteUser = () => useAction(deleteUser);
